import { Fragment, useRef } from 'react';
import ReactSelect from 'react-select';
import ChevronIcon from 'components/common/ChevronFaIcon';
import InputField from 'components/common/Study/InputField/index';
import styles from '../styles.scss';
import { customStylesV2 } from 'components/common/Dropdown/DropDownListHelper';

export default function GroupedUsersSelect({ canManageUsers, useGroupedSelect, handleUserSelected, selectedValue, label, placeholder, studyTeam, notStudyTeam, notValid }) {
    const selectRef = useRef(null);
    function getOptions(team, type) {
        if(!canManageUsers && type === 'notTeamMember' || !team) {
            return [];
        }
        const emptyLabel = {
            teamMember: 'All users on the Study Team have been added to the Delegation.',
            notTeamMember: 'All users not on the Study Team have been added to the Delegation.'
        };

        const options = team.map(el => ({
            ...el, label: el.displayName, value: el.userId ? el.userId : el.id
        }));

        if(options.length === 0) {
            options.push({label: emptyLabel[type], noOptionsLabel: true, isDisabled: true});
        }

        return options;
    }
    const groupedOptions = [
        {
            id: 1,
            text: 'Study Team',
            options: getOptions(studyTeam, 'teamMember')

        },
        {
            id: 2,
            text: 'Not on Study Team',
            options: getOptions(notStudyTeam, 'notTeamMember')
        }
    ];

    const formatGroupLabel = (data) => <div>{data.text}</div>;

    function handleOnChange(value) {
        // input stays focused when menus closes
        selectRef.current.blur();

        if (handleUserSelected) {
            handleUserSelected(value);
        }
    }

    const customStyles = {
        ...customStylesV2,
        control: (base) => ({
            ...base,
            boxShadow: 'unset',
            '&:focus, &:hover': {
                color: '#28282E',
                boxShadow: 'unset',
                borderColor: '#2057AD'
            },
        }),
        groupHeading: () => ({
            backgroundColor: '#2057AD',
            color: '#fff',
            padding: '0rem 0.5rem',
            height: '40px',
            fontWeight: 600,
            lineHeight: '20px',
            display: 'flex',
            alignItems: 'center',
        }),
        group: () => ({
            padding: '0px'
        }),
        singleValue: () => ({
            color: '#28282E',
            fontWeight: '400',
            fontStyle: 'normal',
            fontFamily: 'Hind'
        }),
        option: (base, { data, isSelected }) => {
            const { noOptionsLabel } = data;
            let selectedBg = '#2684FF';
            let hoveredBg = '#DEEBFF';
            let activeBg = '#B2D4FF';

            if (isSelected) {
                hoveredBg = selectedBg;
                activeBg = selectedBg;
            } else if(noOptionsLabel) {
                hoveredBg = 'initial';
                activeBg = 'initial';
            }
            return {
                ...base,
                textAlign: noOptionsLabel && 'center',
                backgroundColor: isSelected  ? selectedBg : 'initial',
                color: isSelected ? '#FFF' : '#28282E',
                fontFamily: 'Hind',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '20px',
                padding: '10px',
                '&:hover': {
                    backgroundColor: hoveredBg
                },
                '&:active': {
                    backgroundColor: activeBg
                }
            };
        }
    };

    const filterOptions = (candidate, input) => {
        if(input && candidate.data.noOptionsLabel) {
            return false;
        }
        return candidate.label.toLowerCase().includes(input.toLowerCase());
    };

    return (
        <Fragment>

            <InputField
                label={label}
                required={true}
                htmlFor='userSelection'
                customClasses={{
                    inputWrapper: styles.inputWrapper
                }}
            >
                <ReactSelect
                    id='userSelection'
                    ref={selectRef}
                    placeholder={placeholder}
                    value={selectedValue}
                    className={notValid && styles.invalidInput }
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: '#2057AD',
                        },
                    })}
                    options={useGroupedSelect ? groupedOptions : studyTeam}
                    styles={customStyles}
                    formatGroupLabel={formatGroupLabel}
                    onChange={handleOnChange}
                    filterOption={filterOptions}
                    components={{ DropdownIndicator: () => <ChevronIcon customStyles={{ padding: '4px', paddingRight:'8px' }} /> }}

                />
            </InputField>
        </Fragment>
    );
}
